<template>
  <ErrorLayout
    :title="'Page not found'"
    :lead="'404 Not Found'">
    <p>
      Sorry, but the page you were looking for cannot be found.
    </p>
    <p>
      If this continues to be a problem, please contact <a
        class="underline text-royal-blue-100 hover:text-royal-blue-160 focus:text-royal-blue-160 visited:text-visited"
        href="mailto:RSC1@rsc.org?subject=AX%20Pilot%20System%20404%20Error">Customer Services</a>.
    </p>
  </ErrorLayout>
</template>

<script setup lang="ts">
import ErrorLayout from '@/layouts/ErrorLayout.vue'
</script>
